import axios from 'axios';

import { ResponseObj, ConviteUsuarioNovoFormData } from '../../../back/src/types';
import { ConviteUsuario } from '../../../back/src/entity/ConviteUsuario';

const conviteUsuario = async (token: string): Promise<ResponseObj<ConviteUsuario>> => {
  const res = await axios.get<ResponseObj<ConviteUsuario>>(`convites_usuarios/${token}`);
  return res.data;
};

const convitesUsuarios = async (): Promise<ResponseObj<ConviteUsuario[]>> => {
  const res = await axios.get<ResponseObj<ConviteUsuario[]>>('convites_usuarios');
  return res.data;
};

const criaConviteUsuario = async (
  formData: ConviteUsuarioNovoFormData,
): Promise<ResponseObj<ConviteUsuario>> => {
  const res = await axios.post<ResponseObj<ConviteUsuario>>('convites_usuarios', formData);
  return res.data;
};

const deletaConviteUsuario = async (conviteUsuarioId: number): Promise<ResponseObj<any>> => {
  const res = await axios.delete<ResponseObj<any>>(`convites_usuarios/${conviteUsuarioId}`);
  return res.data;
};

export default {
  conviteUsuario,
  convitesUsuarios,
  criaConviteUsuario,
  deletaConviteUsuario,
};
